<div class="message-page">

  <div class="message-sub-header">
    <div class="sub-header" [ngClass]="{'mat-elevation-z5' : true, 'sticky' : isSticky}">
      
      <div class="header-content">
        <h2 class="heading-title">Messages</h2>
  
        <div class="search-refresh">
          <div class="search-box">
            <div class="field-group selectfield">
              <mat-form-field appearance="outline" class="custom-form-field">
                <button mat-button class="add" mat-icon-button matPrefix>
                  <mat-icon class="material-icons">search</mat-icon>
                </button>
                <input
                  type="text"
                  placeholder="Search anything"
                  aria-label="Number"
                  matInput
                />
                <button mat-button class="add" mat-icon-button matSuffix>
                  <mat-icon class="material-icons">filter_list</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
  
          <button mat-stroked-button class="refresh-btn">
            <mat-icon>refresh</mat-icon>
            Refresh
          </button>
        </div>
      </div>
    </div>
  
  </div>
  <div class="message-content">
    <div class="message-content-top ">
      <div class="compose-select-section">

        <button mat-stroked-button class="compose-btn" (click)="compose()">
          <mat-icon>edit</mat-icon>
          Compose
        </button>
    
        <button
          type="button"
          class="select-mail"
          mat-button
          mat-stroked-button
          [matMenuTriggerFor]="menu"
        >
          <span class="material-icons">email</span> Inbox<mat-icon
            >keyboard_arrow_down</mat-icon
          >
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-icon class="material-icons">email</mat-icon>
            <span>Inbox</span>
          </button>
          <button mat-menu-item>
            <mat-icon class="material-icons">send</mat-icon>
            <span>Sent</span>
          </button>
          <button mat-menu-item>
            <mat-icon class="material-icons">drafts</mat-icon>
            <span>Drafts</span>
          </button>
          <button mat-menu-item>
            <mat-icon class="material-icons">archive</mat-icon>
            <span>Archived</span>
          </button>
          <button mat-menu-item>
            <mat-icon class="material-icons">delete</mat-icon>
            <span>Trash</span>
          </button>
        </mat-menu>

        <!-- <div class="field-group selectfield">
          <mat-form-field appearance="fill" class="selectfield">
              <mat-select>
                  <mat-option value="0"><mat-icon class="material-icons">email</mat-icon> <span>Sent</span></mat-option>
                  <mat-option value="1"><mat-icon class="material-icons">drafts</mat-icon><span>Drafts</span></mat-option>
                  <mat-option value="2"><mat-icon class="material-icons">archive</mat-icon><span>Archived</span></mat-option>
                  <mat-option value="3"><mat-icon class="material-icons">delete</mat-icon><span>Trash</span></mat-option>
              </mat-select>
          </mat-form-field>
        
      </div> -->


      </div>
    </div>
  
    <div class="message-header">
      <mat-checkbox></mat-checkbox>
  
      <div class="select-message-type">
        <button
          type="button"
          class="select-mail"
          mat-button
          mat-icon-button
          [matMenuTriggerFor]="menuSelectMsg"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menuSelectMsg="matMenu">
          <button mat-menu-item>Select All</button>
          <button mat-menu-item>Select None</button>
          <button mat-menu-item>Mark as Read</button>
        </mat-menu>
      </div>
  
      <div class="message-from">
        <button
          type="button"
          class="select-mail"
          mat-button
          mat-icon-button
          [matMenuTriggerFor]="menuSelectMsg"
        >
          From<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div class="message">
        <button
          type="button"
          mat-button
          mat-icon-button
          
        >
          Message<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div class="date-time">
        <button
          type="button"
          mat-button
          mat-icon-button
        >
          Date & Time<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>
  
    <div class="message-section">
      <div class="message-section-responsive">
        <div class="avatar">
          <span>AA</span>
        </div>
        <div class="message-section-content">
  
          <div class="check-message">
            <mat-checkbox></mat-checkbox>
          </div>
  
          <div class="message-sender">
            <mat-label class="labelsuper">monday.com </mat-label>
            <div class="badge">4</div>
            
          </div>
          <div class="subject-message">
            <mat-label class="labelsuper">Welcome! Onboard</mat-label>
            <mat-label
              >monday.​com is so flexible, you can manage just about everything with
              it
            </mat-label>
          </div>
          <div class="date-time">
            <mat-label>Mon, Sep 20, 2:40 PM</mat-label>
          </div>
  
          <div class="message-options">
            <div class="attachment">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>attachment</mat-icon>
              </button>
            </div>
            <!-- <a href="" class="attachment"><mat-icon>attachment</mat-icon></a> -->
            <div class="message-hover-option">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>archive</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>mark_email_read</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>reply</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="message-section">
      <div class="message-section-responsive">
        <div class="avatar">
          <span>AA</span>
        </div>
        <div class="message-section-content">
  
          <div class="check-message">
            <mat-checkbox></mat-checkbox>
          </div>
  
          <div class="message-sender">
            <mat-label class="labelsuper">monday.com </mat-label>
            <div class="badge">4</div>
            
          </div>
          <div class="subject-message">
            <mat-label class="labelsuper">Welcome! Onboard</mat-label>
            <mat-label
              >monday.​com is so flexible, you can manage just about everything with
              it
            </mat-label>
          </div>
          <div class="date-time">
            <mat-label>Mon, Sep 20, 2:40 PM</mat-label>
          </div>
  
          <div class="message-options">
            <div class="attachment">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>attachment</mat-icon>
              </button>
            </div>
            <!-- <a href="" class="attachment"><mat-icon>attachment</mat-icon></a> -->
            <div class="message-hover-option">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>archive</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>mark_email_read</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>reply</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="message-section">
      <div class="message-section-responsive">
        <div class="avatar">
          <span>AA</span>
        </div>
        <div class="message-section-content">
  
          <div class="check-message">
            <mat-checkbox></mat-checkbox>
          </div>
  
          <div class="message-sender">
            <mat-label class="labelsuper">monday.com </mat-label>
            <div class="badge">4</div>
            
          </div>
          <div class="subject-message">
            <mat-label class="labelsuper">Welcome! Onboard</mat-label>
            <mat-label
              >monday.​com is so flexible, you can manage just about everything with
              it
            </mat-label>
          </div>
          <div class="date-time">
            <mat-label>Mon, Sep 20, 2:40 PM</mat-label>
          </div>
  
          <div class="message-options">
            <div class="attachment">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>attachment</mat-icon>
              </button>
            </div>
            <!-- <a href="" class="attachment"><mat-icon>attachment</mat-icon></a> -->
            <div class="message-hover-option">
              <button type="button" mat-button mat-icon-button>
                <mat-icon>archive</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>mark_email_read</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>reply</mat-icon>
              </button>
              <button type="button" mat-button mat-icon-button>
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    
  
    <div class="message-pagination">
      <div class="total-message">
        <mat-label>Showing 4 of 4 results</mat-label>
      </div>
      <div class="back-next">
        <button type="button" mat-button mat-icon-button>
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
  
        <mat-label>1</mat-label>
  
        <button type="button" mat-button mat-icon-button>
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
  
      <div class="page-list">
        <mat-label>Items per page</mat-label>
        <button
          type="button"
          class="select-page"
          mat-button
          mat-stroked-button
          [matMenuTriggerFor]="selectPage"
        >
          10<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #selectPage="matMenu">
          <button mat-menu-item>
            <span>1</span>
          </button>
          <button mat-menu-item>
            <span>2</span>
          </button>
          <button mat-menu-item>
            <span>5</span>
          </button>
          <button mat-menu-item>
            <span>10</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>


<!-- ================== OLD DESIGN WITH FUNCTIONALLY =============== -->

<!--
    <app-sub-header 
[header]="'Message Center'"
[currentStage]="-1"
[totalStage]=""
></app-sub-header> 
    
    <section class="main-container main-container-sidenav finacial-goal">
    <div class="container container-super">
    






        <div class="notification-page">
            <div class="notification-list">
                <mat-tab-group class="list-header">
                    <mat-tab class="received">
                        <ng-template mat-tab-label>
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 0.25H14L15.5 3.25V13C15.5 13.1989 15.421 13.3897 15.2803 13.5303C15.1397 13.671 14.9489 13.75 14.75 13.75H1.25C1.05109 13.75 0.860322 13.671 0.71967 13.5303C0.579018 13.3897 0.5 13.1989 0.5 13V3.253L2 0.25ZM14 4.75H2V12.25H14V4.75ZM13.823 3.25L13.073 1.75H2.92775L2.17775 3.25H13.823ZM8.75 8.5H11L8 11.5L5 8.5H7.25V5.5H8.75V8.5Z" fill="#4C5A52"/>
                            </svg>
                            <mat-label class="labelsuper margin-left1">Received</mat-label>
                            <mat-chip 
                            class="received-chip">
                                1
                            </mat-chip>
                        </ng-template>
                        <div class="notification-search">
                            <div class="search-field">
                                <div class="field-group">
                                  
                                    <mat-form-field appearance="outline" class="custom-form-field">
                                        <input type="text" #search
                                        (keyup)="searchNotification(search.value)"
                                        placeholder="Search..."
                                       aria-label="Number"
                                        matInput
                                      >
                                     
            
                                        <button mat-button class="add" mat-icon-button matSuffix >
                                          <mat-icon class="material-icons green-text">search</mat-icon>
                                          </button>
            
                                       </mat-form-field>
                                </div>
        
                            </div>
                            
                            
                            <div class="total-notification">
                                <mat-label class="labelsuper">Total Message ({{filteredNotification.length}})</mat-label>
            
                                </div>
                                
                                
                           
                            </div>
                        
                        <div class="total-message">
                            <div class="notification-message" *ngFor="let element of filteredNotification" (click)="showfullNotifi(element.allnotifi,element.subject)">
                               
                                    <div class="avatar">
                                        <img src="../../../assets/images/avatar.jpg" alt="">
                                        
                                    </div>
                                    <div class="message-content">
                                        <div class="message-header">
                                            <div class="name">
                                                <mat-label class="labelsuper">{{element.allnotifi[0].createdBy}}</mat-label>
                                                <div class="message-active" *ngIf="element.allnotifi[0].statecode == 0"></div>
                
                                            </div>
                                            <div class="time">
                                                <p class="lighten">{{element.allnotifi[0].createdOn}}</p>
                
                                            </div>
                                        </div>
                                        <div class="message">
                                            <mat-label class="labelsuper-normal400">
                                                {{element.allnotifi[0].subject| slice:0:50}}.....
                                            </mat-label>
                                        </div>
                
                                    </div>
                                
                             
                            </div>
                           
                          
                            
                        </div>
                        
                    </mat-tab>
                  
                    <mat-tab class="sent">
                      <ng-template mat-tab-label>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.80575 0.0562015L14.6522 7.6717C14.711 7.70407 14.7601 7.75163 14.7942 7.80941C14.8284 7.8672 14.8464 7.93308 14.8464 8.0002C14.8464 8.06732 14.8284 8.13321 14.7942 8.19099C14.7601 8.24877 14.711 8.29633 14.6522 8.3287L0.80575 15.9442C0.748655 15.9756 0.684361 15.9916 0.619205 15.9906C0.554049 15.9896 0.490279 15.9716 0.434182 15.9385C0.378086 15.9053 0.331597 15.8581 0.2993 15.8015C0.267003 15.7449 0.250011 15.6809 0.25 15.6157V0.384701C0.250011 0.319537 0.267003 0.255501 0.2993 0.198904C0.331597 0.142307 0.378086 0.0951027 0.434182 0.0619442C0.490279 0.0287858 0.554049 0.0108174 0.619205 0.00981042C0.684361 0.00880339 0.748655 0.0247924 0.80575 0.0562015ZM1.75 8.7502V13.713L12.1375 8.0002L1.75 2.28745V7.2502H5.5V8.7502H1.75Z" fill="#4C5A52"/>
                            </svg>
                            <mat-label class="labelsuper margin-left1">Sent</mat-label>  
                      </ng-template>
                    </mat-tab>
                  
                    
                  </mat-tab-group>
                  
             
                <button class="compose-message" (click)="compose()">
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="white"/>
                        </svg>
                        
                </button>




            </div>


            <div class="notification-msg" *ngIf="currentSubject">
                <div class="notification-header">
                           <mat-label class="labelsuper">
                       Subject : {{currentSubject}}
                    </mat-label>

             

                </div>

                <div class="notification-msg-list">

                    <div class="message-box">
                        <div class="notification-message" *ngFor="let element of currentThread">
                            <div class="avatar">
                                <img src="../../../assets/images/avatar.jpg" alt="">
        
                            </div>
                            <div class="message-content">
                                <div class="message-header">
                                    <div class="name">
                                        <mat-label class="labelsuper">{{element.createdBy}}</mat-label>
                                        
        
                                    </div>
                                    <div class="time">
                                        <p class="lighten">{{element.createdOn}}</p>
        
                                    </div>
                                </div>
                                <div class="message">
                                    <mat-label class="labelsuper-normal400">
                                        {{element.description}}
                                    </mat-label>
                                </div>
        
                            </div>
                        </div>
                     
                     
                        
                            <div class="reply-header">
                                <div class="left">
                                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.88598 4.66686L4.57665 6.35753L3.63398 7.3002L0.333984 4.0002L3.63398 0.700195L4.57665 1.64286L2.88598 3.33353H7.66732C9.08181 3.33353 10.4384 3.89543 11.4386 4.89563C12.4387 5.89582 13.0007 7.25237 13.0007 8.66686C13.0007 10.0814 12.4387 11.4379 11.4386 12.4381C10.4384 13.4383 9.08181 14.0002 7.66732 14.0002H1.66732V12.6669H7.66732C8.72818 12.6669 9.7456 12.2454 10.4957 11.4953C11.2459 10.7451 11.6673 9.72773 11.6673 8.66686C11.6673 7.606 11.2459 6.58858 10.4957 5.83844C9.7456 5.08829 8.72818 4.66686 7.66732 4.66686H2.88598Z" fill="white"/>
                                    </svg>
                                    <mat-label class="labelsuper-normal">
                                        Reply
                                    </mat-label>
                                        
                                </div>

                                <mat-divider inset vertical class="vertical-divider"></mat-divider>

                                <div class="right">
                                    <mat-label class="labelsuper">From vladimir Rasool  </mat-label>
                                    <p class="lighten"> (vladimirrasool@domain.com)</p>
                                    
                                </div>
                            </div>

                            <div class="reply-subheader">
                                <mat-label class="labelsuper-normal">
                                    Regarding
                                </mat-label>
                                <mat-divider inset vertical class="vertical-divider"></mat-divider>
                                <div class="regarding-chip">
                                    <p class="lighten">Cashel family</p>
                                    <button mat-icon-button >
                                        <mat-icon>close</mat-icon>
                                      </button>


                                    
                                    
                                </div>
                                    
                            </div>
                        </div> 
                    </div>

                    <div class="reply-box">
                       <div class="reply-msg">
                           <textarea matInput placeholder="Type something..." class="reply-msg" #descriptionInput ></textarea>

                       </div>
                        <div class="reply-bottom">
                            <div class="left">
                                <mat-label class="labelsuper-normal">Subject:</mat-label>
    
                                <p class="lighten margin-left1">{{currentSubject}}</p>
                                

                            </div>

                            <div class="right">
                                <button mat-flat-button class="send-reply-btn" (click)="sentMessage(descriptionInput)"> 
                                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.75 7.58327H4.25V6.41661H0.75V1.07677C0.750009 1.02609 0.763224 0.976284 0.788345 0.932264C0.813465 0.888244 0.849622 0.85153 0.893253 0.82574C0.936884 0.79995 0.986482 0.785974 1.03716 0.785191C1.08784 0.784408 1.13784 0.796844 1.18225 0.821273L11.9517 6.74444C11.9975 6.76962 12.0356 6.80661 12.0622 6.85155C12.0887 6.89649 12.1027 6.94774 12.1027 6.99994C12.1027 7.05214 12.0887 7.10339 12.0622 7.14833C12.0356 7.19327 11.9975 7.23026 11.9517 7.25544L1.18225 13.1786C1.13784 13.203 1.08784 13.2155 1.03716 13.2147C0.986482 13.2139 0.936884 13.1999 0.893253 13.1741C0.849622 13.1483 0.813465 13.1116 0.788345 13.0676C0.763224 13.0236 0.750009 12.9738 0.75 12.9231V7.58327Z" fill="white"/>
                                        </svg>
                                        
                                </button>
                            </div>


                        </div>
                    </div>
 
                </div>


            </div>

        </div>

        <div class="button-footer margin-top2">

            <button type="button" class="mat-stepper-next resume-app"  (click)="onBack()">Resume Application</button>
        </div>
        
        
        
        
        
        
    </section> -->

<!-- =============== new notification page 13/04/22 =================== -->

<!-- <div class="avatar-img">{{element.createdBySlug}}</div> -->

<!-- <div class="notification-mail-page margin-top2">
        
        <div class="message-header">

            <div class="compose-inbox">
                <button type="button" class="compose-btn"  (click)="compose()">Compose</button>

                <div class="field-group selectfield width-160">

                    <mat-form-field appearance="fill" class="selectfield">
                        <mat-select >
                            <mat-option value="option1">Inbox</mat-option>
                            <mat-option value="option2">Sent</mat-option>
                            <mat-option value="option3">Deleted</mat-option>
                            <mat-option value="option4">Archive</mat-option>
                          
                        </mat-select>
                    </mat-form-field>
                </div>
   
            </div>
            <div class="search-message">
                <div class="field-group selectfield width-160 margin-right1">
    
                    <mat-form-field appearance="fill" class="selectfield">
                        <mat-select >
                            
                            <mat-option value="option1">All Message</mat-option>
                            <mat-option value="option2">All Message</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
    
                <div class="search-field width-160">
                    <div class="field-group">
                      <mat-form-field appearance="outline" class="custom-form-field">
                        <input
                          type="text"
                          #search
                          placeholder="Search..."
                          aria-label="Number"
                          matInput
                        />
                        <button mat-button class="add" mat-icon-button matSuffix>
                          <mat-icon class="material-icons green-text"
                            >search</mat-icon
                          >
                        </button>
                      </mat-form-field>
                    </div>
                  </div>

            </div>
        </div>
        <mat-divider class="divider"></mat-divider>

        <div class="notification-message">
                           
            <div class="avatar">
                <img src="../../../assets/images/avatar.jpg" alt="">
            </div>
            <div class="message-content">
                <div class="message-header">
                    <div class="name">
                        <mat-label class="labelsuper">Cashel Developer</mat-label>
                        <div class="message-active" ></div>

                    </div>
                    <div class="time">
                        <p class="lighten">12/10/2021 4:07 AM</p>

                    </div>
                </div>
                <div class="message">
                    <mat-label class="labelsuper-normal400">
                        This is is the test message
                    </mat-label>
                </div>

            </div>
        
     
    </div>

    </div> -->

<!-- =============== new notification page END 13/04/22 =================== -->
